// Fired whenever the server refuses something because of the workspace's RFP
// plan (trial or subscription limit, locked workspace, no seats). One popup
// (PlanLimitHost) listens, so every screen gets the same "upgrade" prompt
// without each one handling the error itself.
// Lives outside React so the axios instance and the socket hook can import it.

const PLAN_LIMIT_CODES = new Set(["plan_limit", "team_requires_paid_plan", "seat_limit_reached"]);

const listeners = new Set();
let lastMessage = null;
let lastAt = 0;

export const onPlanLimit = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

// `kind` says which allowance ran out when the caller knows ("projects" gets the popup with the seat
// maths); without it the popup just shows the message.
export const emitPlanLimit = (message, kind) => {
  lastMessage = message;
  lastAt = Date.now();
  listeners.forEach((listener) => {
    try {
      listener(message, kind);
    } catch (_) {
      // one bad subscriber shouldn't break the others
    }
  });
};

// The popup already says this, so a screen's own error toast for the same text is noise.
export const wasJustShown = (message) => Boolean(message) && message === lastMessage && Date.now() - lastAt < 5000;

export const isPlanLimitError = (error) => PLAN_LIMIT_CODES.has(error?.response?.data?.error_code);

export const planLimitMessage = (error) => {
  const data = error?.response?.data || {};
  return data.error || data.msg || data.message || "Your plan doesn't include this. Choose a plan to continue.";
};
